import { DownOutlined } from '@ant-design/icons';
import {
  Col,
  Collapse,
  CollapseProps,
  Divider,
  Layout,
  Radio,
  Row,
  Space,
  Timeline,
} from 'antd';
import Sider from 'antd/es/layout/Sider';
import { Content } from 'antd/es/layout/layout';
import { ColumnsType } from 'antd/es/table';
import { Table } from 'antd/lib';
import CapitalApi from 'apis/CapitalApi';
import DropdownComponent from 'components/DropdownComponent';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import formatCurrencyVND from 'utils/formatCurrencyVND';

interface Iprops {
  shopCapital: any;
  capitalDetail: any;
}

export default function AllocationCapital(props: Iprops) {
  const { shopCapital, capitalDetail } = props;

  const [dataLog, setDataLog] = useState<any[]>([]);
  const [colorText, setColorText] = useState<any>();

  const { mutate: listLogApprove } = useMutation(['getlogApprove'], () => {
    return CapitalApi.getlogApprove(capitalDetail?.capital_id)
      .then((res) => {
        setDataLog(res?.data);
        setColorText(
          res?.data[0].status == 0
            ? 'text-primary-50'
            : res?.data[0].status == 1
            ? 'text-primary-50'
            : 'text-red-500'
        );
      })
      .catch((err) => {
        console.log(err);
      });
  });

  useEffect(() => {
    listLogApprove();
  }, [capitalDetail]);

  const items_right_detail: CollapseProps['items'] = [
    {
      key: '1',
      label: <h6 className="text-base text-primary-50 mb-4"> Xem chi tiết</h6>,
      children: (
        <div>
          <Row>
            <Col span={8}>Quận/Huyện</Col>
            <Col span={16} className="flex justify-end">
              {capitalDetail?.district}
            </Col>

            <Col span={8}>Tier</Col>
            <Col span={16} className="flex justify-end">
              {capitalDetail?.tier_name}
            </Col>

            <Col span={8}>MHKD</Col>
            <Col span={16} className="flex justify-end">
              {capitalDetail?.type_name}
            </Col>

            <Col span={8}>Cấp CH</Col>
            <Col span={16} className="flex justify-end">
              {capitalDetail?.class_name}
            </Col>

            <Divider
              style={{
                borderTop: '1px dashed rgba(0, 0, 0, 0.2)',
                marginTop: '8px',
                marginBottom: '8px',
              }}
            />

            <Col span={24}>Vốn đăng ký</Col>
            <Col
              span={11}
              className="flex justify-center bg-primary-50 text-white mr-2"
            >
              Min
            </Col>
            <Col
              span={11}
              className="flex justify-center bg-primary-50 text-white"
            >
              Max
            </Col>
            <Col span={11} className="mr-2">
              {formatCurrencyVND(shopCapital?.capital_min)}
            </Col>
            <Col span={11}>{formatCurrencyVND(shopCapital?.capital_max)}</Col>
            <Col span={24}>Chi nhánh phân bổ</Col>
            <Col
              span={11}
              className="flex justify-center bg-primary-50 text-white mr-2"
            >
              Min
            </Col>
            <Col
              span={11}
              className="flex justify-center bg-primary-50 text-white"
            >
              Max
            </Col>
            <Col span={11} className="mr-2">
              {formatCurrencyVND(shopCapital?.capital_from_branch_min)}
            </Col>
            <Col span={11}>
              {formatCurrencyVND(shopCapital?.capital_from_branch_max)}
            </Col>
          </Row>
        </div>
      ),
    },
  ];
  const items_right: CollapseProps['items'] = [
    {
      key: '1',
      label: (
        <h6 className="text-base text-primary-50 mb-4"> Thông tin đăng ký</h6>
      ),
      children: (
        <div>
          <Row>
            <Col span={24} className="">
              {capitalDetail?.code} - {capitalDetail?.name}
            </Col>
            <Col span={24} className="text-base text-primary-50 mb-4">
              <Collapse
                expandIconPosition="right"
                ghost
                expandIcon={({ isActive }) => (
                  <DownOutlined rotate={isActive ? 180 : 0} />
                )}
                size="small"
                items={items_right_detail}
              />
            </Col>
          </Row>
        </div>
      ),
    },
  ];

  const items_right_history_detail = dataLog.map((item, index) => {
    return {
      children: (
        <Space className="w-full" key={index} direction="vertical">
          <Row>
            <Col span={16} className="text-base">
              {moment(item.created_at).format('DD/MM/YYYY HH:mm')}
            </Col>
            <Col span={8} className={`text-base ${colorText}`}>
              {item.status == 0
                ? 'Mới tạo'
                : item.status == 1
                ? 'Chờ phê duyệt'
                : item.status == 2
                ? 'Đã duyệt'
                : item.status == 3
                ? 'Từ chối'
                : 'Chưa tạo'}
            </Col>
            <Col span={24} className="text-base mt-4">
              {item.user_created.fullName +
                '  |  ' +
                item.user_created.jobTitle}
            </Col>
            <Col span={24} className="text-base text-red-500">
              {item.note}
            </Col>
          </Row>
        </Space>
      ),
    };
  });

  return (
    <Layout
      style={{
        backgroundColor: 'white',
      }}
    >
      <Collapse
        expandIconPosition="right"
        ghost
        expandIcon={({ isActive }) => (
          <DownOutlined rotate={isActive ? 180 : 0} />
        )}
        size="small"
        items={items_right}
        defaultActiveKey={['1']}
      />
      <Divider
        style={{
          borderTop: '10px solid',
          borderColor: '#F1F9FF',
          marginTop: '8px',
          marginBottom: '8px',
        }}
        dashed
      />
      <DropdownComponent title="Lịch sử phê duyệt">
        <Timeline items={items_right_history_detail} />
      </DropdownComponent>
    </Layout>
  );
}
